import { t } from '../../i18n/i18n';

const setAcademicLevels = (academicFilter) =>
  academicFilter.map((filter) => ({
    ...filter,
    ...{ name: t(`PROFILES_FILTER_ACADEMIC_STATUS_${filter?.name.toUpperCase()}`) },
  }));

export default setAcademicLevels;
